/**
 * The "this verdict looks wrong" control of an opened ✗ note (#438 slice 3): a quiet button, then a one-step confirm, then the
 * POST (the caller's). Nothing on the note changes until the server answers 201; the caller decides what a failure says.
 */

import { useState } from 'react';
import { useFeedbackLabels } from '../../i18n/homework-feedback-labels.js';

export function DisputeControl(props: { readonly onConfirm: () => Promise<void> }): React.JSX.Element {
  const t = useFeedbackLabels();
  const [confirming, setConfirming] = useState(false);
  const [sending, setSending] = useState(false);
  if (!confirming) {
    return (
      <button type="button" className="fb-dispute-open" onClick={() => setConfirming(true)}>
        {t.disputeAction}
      </button>
    );
  }
  return (
    <div className="feedback-dispute" role="group" aria-label={t.disputeAction}>
      <p>{t.disputeConfirmQuestion}</p>
      <button
        type="button"
        disabled={sending}
        onClick={() => {
          setSending(true);
          void props.onConfirm().finally(() => {
            setSending(false);
            setConfirming(false);
          });
        }}
      >
        {t.disputeConfirmAction}
      </button>{' '}
      <button type="button" className="button-quiet" disabled={sending} onClick={() => setConfirming(false)}>
        {t.disputeCancelAction}
      </button>
    </div>
  );
}
